import { OpravnenieEnum, UserApi, UserDetail } from 'vestniky-frontend-ts-axios';
import { ClientResponse } from '../../model/types/ClientResponse';
import CurrentUserDetail from '../../model/currentuser/CurrentUserDetail';
import apiConfiguration from '../configuration/apiConfiguration';
import { vestnikyPrefixPath } from '../configuration/apiConfigurationConstants';
import UserRole from '../../model/currentuser/UserRole';

const client = new UserApi(apiConfiguration(vestnikyPrefixPath));

export const fetchCurrentPouzivatel = async (options?: { headers?: object }): Promise<ClientResponse<UserDetail>> => {
  const {
    data,
    status,
  } = await client.getCurrentUser(options);

  return {
    data: map(data),
    responseCode: status,
  };
};

const map = (data: UserDetail): CurrentUserDetail => ({
  meno: data.meno,
  uuid: data.uuid,
  organizaciaNazov: data.organizaciaNazov,
  organizaciaSkratka: data.organizaciaSkratka,
  organizaciaUuid: data.organizaciaUuid,
  organizaciaCiselnikyUuid: data.organizaciaCiselnikyUuid,
  roles: mapRoleList(data.opravnenieList),
});

const mapRoleList = (roleList: OpravnenieEnum[]): UserRole[] => (
  !roleList ? [] : roleList.map(opravnenie => UserRole[opravnenie])
);
